<script setup lang="ts">
// Character pages are user-themed and designed on dark surfaces, so they
// always render in dark mode regardless of the visitor's preference. The
// forced flag is restored when navigating back into the app.
const colorMode = useColorMode()

colorMode.forced = true
colorMode.value = 'dark'

onUnmounted(() => {
  colorMode.forced = false
  colorMode.value = colorMode.preference === 'system'
    ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    : colorMode.preference
})
</script>

<template>
  <div class="dark min-h-dvh bg-[#03020A]">
    <slot />
  </div>
</template>
